export const item = [
  {
    name: "Personal Information",
    value: "1",
    sub: "Enter employee's basic information",
  },
  {
    name: "Employment 201",
    value: "2",
    sub: "Employment Details",
  },
  {
    name: "Other Information",
    value: "3",
    sub: "Supplemental information",
  },
  {
    name: "Additional Information",
    value: "4",
    sub: "Additional information",
  },
  {
    name: "Attachments",
    value: "5",
    sub: "Supporting documents",
  },
];
